import Admin from "./Admin";

function App() {
  return <Admin />;
}

export default App;